import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { ReportIssueTable } from "./ReportIssueTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  useForceUpdate,
  useStyles,
  useStylesReddit,
  validatePost,
  validateDateFields,
  showSuccessDialog,
} from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  fetchGroupCountry,
  fetchGroupPhoneType,
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
} from "../businessParameter/businessParameterSlice";

import {
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchReportIssue,
  selectReportIssue,
  fetchReportIssueDownload,
} from "./reportIssueSlice";
import { fetchClient } from "../client/clientSlice";
import { ModalClientRadio } from "../report/ModalClientRadio";
import { FormHelperText } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ModalCreateReportIssue } from "./ModalCreateReportIssue";
import {
  fetchReasonCode,
  selectReasonCode,
} from "../miscellaneous/MiscellaneousSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ReportIssueTab = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectReportIssue);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();
  const dataReason = useSelector(selectReasonCode);

  // Filter
  const [value, setValue] = useState(0);
  const [force, setForce] = useState(false);

  // initial

  const [formValues, setFormValues] = useState({
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    vin: {
      value: "",
      error: false,
      required: "N",
    },
    hold_reason: {
      value: "",
      error: false,
      required: "N",
    },
    hold_remarks: {
      value: "",
      error: false,
      required: "N",
    },
    issue_start_date: {
      value: "",
      error: false,
      required: "N",
    },
    issue_end_date: {
      value: "",
      error: false,
      required: "N",
    },
    inspection_status: {
      value: "",
      error: false,
      required: "N",
    },
    issuer: {
      value: "",
      error: false,
      required: "N",
    },
    resolution_start_date: {
      value: "",
      error: false,
      required: "N",
    },
    resolution_end_date: {
      value: "",
      error: false,
      required: "N",
    },
    resolution_remarks: {
      value: "",
      error: false,
      required: "N",
    },
    resolver: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const [fieldsFilter, setFieldsFilter] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const [formData, setFormData] = useState({
    reportissue_id: {
      value: "",
      error: false,
      required: "N",
    },
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    issue_date: {
      value: "",
      error: false,
      required: "Y",
    },
    hold_reason: {
      value: "",
      error: false,
      required: "N",
    },
    hold_remarks: {
      value: "",
      error: false,
      required: "N",
    },
    resolve_date: {
      value: "",
      error: false,
      required: "N",
    },
    resolve_remarks: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const [btnHideFilter, setBtnHideFilter] = useState(false);
  const [showClient, setShowClient] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [getDataClient, setGetDataClient] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    dispatch(resetData());
  }, [dispatch]);

  // Fungsi untuk mengubah nilai btnHide antara true dan false
  const toggleBtnHideFilter = () => {
    setBtnHideFilter(!btnHideFilter);
  };

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchClient({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchReasonCode({
          reasoncode_type: "H2",
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setForce(false);
    }
  }, [force]);

  const handleSearch = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    let params = {
      pageNo: 1,
      pageSize: paginationSet,
      client: formValues.client_name.value,
      vin: formValues.vin.value,
      hold_reason: formValues.hold_reason.value,
      hold_remarks: formValues.hold_remarks.value,
      issue_start_date: formValues.issue_start_date.value,
      issue_end_date: formValues.issue_end_date.value,
      inspection_status: formValues.inspection_status.value,
      issuer: formValues.issuer.value,
      resolution_start_date: formValues.resolution_start_date.value,
      resolution_end_date: formValues.resolution_end_date.value,
      resolution_remarks: formValues.resolution_remarks.value,
      resolver: formValues.resolver.value,
    };

    try {
      const response = await dispatch(fetchReportIssue(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        pageNo: page,
        pageSize: sizePerPage,
        client: formValues.client_name.value,
        vin: formValues.vin.value,
        hold_reason: formValues.hold_reason.value,
        hold_remarks: formValues.hold_remarks.value,
        issue_start_date: formValues.issue_start_date.value,
        issue_end_date: formValues.issue_end_date.value,
        inspection_status: formValues.inspection_status.value,
        issuer: formValues.issuer.value,
        resolution_start_date: formValues.resolution_start_date.value,
        resolution_end_date: formValues.resolution_end_date.value,
        resolution_remarks: formValues.resolution_remarks.value,
        resolver: formValues.resolver.value,
      };

      try {
        const response = await dispatch(fetchReportIssue(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const optionsHold = [
    { label: "HOLD", value: "HOLD" },
    { label: "Un-hold", value: "Un-hold" },
  ];

  const optionsStatus = [
    { label: "OK", value: "OK" },
    { label: "NG", value: "NG" },
  ];

  const reasonOptions = dataReason.map((e) => {
    return {
      value: e.reasoncode_id,
      label: e.reasoncode_code,
      name: e.reasoncode_name,
    };
  });

  const handleDownload = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return 
    }
    
    let params = {
      VIN: formValues.vin.value,
      InspectionStatus: formValues.inspection_status.value,
      HoldReasonCode: formValues.hold_reason.value,
      ResolutionStartDate: formValues.resolution_start_date.value,
      ResolutionEndDate: formValues.resolution_end_date.value,
      IssueStartDate: formValues.issue_start_date.value,
      IssueEndDate: formValues.issue_end_date.value,
      ResolutionRemark: formValues.resolution_remarks.value,
      Resolver: formValues.resolver.value,
      Client: formValues.client_name.value
    };

    try {
      const response = await dispatch(
        fetchReportIssueDownload(params)
      );
      if (response.payload.status === 200) {
        showSuccessDialog(response.payload.data.message);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <Button
              className="btn btn-primary my-btn-primary-dark text-bold mb-5"
              onClick={toggleBtnHideFilter}
            >
              <span
                className="svg-icon svg-icon-md svg-icon-light"
                style={{ marginRight: "0px" }}
              >
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/New/SearchParameter.svg"
                  )}
                  className="mr-2"
                />
              </span>
              Search Parameter
            </Button>

            {btnHideFilter === true && (
              <>
                <div className="mb-5">
                  <ThemeProvider theme={formLabelsTheme}>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              required
                              label="Client"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.client_name.value}
                              readOnly
                              error={formValues.client_name.error}
                              helperText={
                                formValues.client_name.error ? (
                                  <FormHelperText
                                    sx={{ mt: "5px", mb: "-10px" }}
                                  >
                                    {iconError} {"This field is required"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )
                              }
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <div>
                              <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setShowClient(true);
                                    setGetDataClient(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                          {formValues.client_name.value !== "" && (
                            <Col xs={1} sm={1} md={1} lg={1}>
                              <div
                                style={{ marginTop: "22px", cursor: "pointer" }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,

                                    ["client_name"]: {
                                      ...formValues["client_name"],
                                      value: "",
                                    },
                                  });
                                }}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/x-square.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="VIN"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="text"
                              size="small"
                              name="vin"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.vin.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              options={reasonOptions}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              getOptionName={(option) => option.name}
                              value={
                                reasonOptions.find(
                                  (option) =>
                                    option.value ===
                                    formValues.hold_reason.value
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                console.log(newValue, "newValue");
                                if (newValue === null) {
                                  setFormValues({
                                    ...formValues,
                                    ["hold_reason"]: {
                                      ...formValues["hold_reason"],
                                      value: "",
                                    },
                                    ["hold_remarks"]: {
                                      ...formValues["hold_remarks"],
                                      value: "",
                                    },
                                  });
                                } else {
                                  console.log(newValue.name, " newValue.name");

                                  setFormValues({
                                    ...formValues,
                                    ["hold_reason"]: {
                                      ...formValues["hold_reason"],
                                      value: newValue.value,
                                    },
                                    ["hold_remarks"]: {
                                      ...formValues["hold_remarks"],
                                      value: newValue.name,
                                    },
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Hold Reason"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="hold_reason"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Hold Remark"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="text"
                              size="small"
                              name="hold_remarks"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.hold_remarks.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={5} lg={5}>
                            <RedditTextField
                              label="Issue Date From"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="datetime-local"
                              size="small"
                              name="issue_start_date"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.issue_start_date.value}
                            />
                          </Col>
                          <Col xs={10} sm={3} md={5} lg={5}>
                            <RedditTextField
                              label="Issue Date Until"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="datetime-local"
                              size="small"
                              name="issue_end_date"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.issue_end_date.value}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              options={optionsStatus}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              value={
                                optionsStatus.find(
                                  (option) =>
                                    option.value ===
                                    formValues.inspection_status.value
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                if (newValue === null) {
                                  setFormValues({
                                    ...formValues,
                                    ["inspection_status"]: {
                                      ...formValues["inspection_status"],
                                      value: "",
                                    },
                                  });
                                } else {
                                  setFormValues({
                                    ...formValues,
                                    ["inspection_status"]: {
                                      ...formValues["inspection_status"],
                                      value: newValue.value,
                                    },
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Inspection Status"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="country_id"
                                  value={formValues.inspection_status.value}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Issuer"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="text"
                              size="small"
                              name="issuer"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.issuer.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={5} lg={5}>
                            <RedditTextField
                              label="Resolution Date From"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="datetime-local"
                              size="small"
                              name="resolution_start_date"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.resolution_start_date.value}
                            />
                          </Col>
                          <Col xs={10} sm={3} md={5} lg={5}>
                            <RedditTextField
                              label="Resolution Date Until"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="datetime-local"
                              size="small"
                              name="resolution_end_date"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.resolution_end_date.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Resolution Remark"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="text"
                              size="small"
                              name="resolution_remarks"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.resolution_remarks.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Resolver"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="text"
                              size="small"
                              name="resolver"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.resolver.value}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </ThemeProvider>
                </div>

                <Row className="mt-6 justify-content-between">
                  <Col>
                    <Button
                      className="btn btn-primary my-btn-primary-dark text-bold mr-3"
                      onClick={() => setShowReport(true)}
                    >
                      {" "}
                      Report Issue
                    </Button>
                  </Col>

                  <Col>
                    <Row className="justify-content-end">
                      <Button className="mr-3" onClick={handleDownload}>
                        <span
                          className="svg-icon svg-icon-md svg-icon-light"
                          style={{ marginRight: "0px" }}
                        >
                          <SVG
                            src={toAbsoluteUrl("/media/svg/icons/New/XLS.svg")}
                          />
                        </span>
                        Download
                      </Button>
                      <Button
                        className="mr-3 btn-filter"
                        variant="primary"
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                    </Row>
                  </Col>
                </Row>
              </>
            )}

            <ReportIssueTable
              data={data === null ? [] : data}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
              handleSearch={handleSearch}
              setFormValues={setFormData}
              formValues={formData}
              isOpen={showReport}
              setShow={setShowReport}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
          </CardBody>
        </Card>

        <ModalClientRadio
          isOpen={showClient}
          setShow={setShowClient}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFieldsFilter}
          fields={fieldsFilter}
          getData={getDataClient}
          setGetData={setGetDataClient}
        />

        <ModalCreateReportIssue
          isOpen={showReport}
          setShow={setShowReport}
          setFormValues={setFormData}
          formValues={formData}
        />
      </div>
    </>
  );
};
